import { Injectable } from '@angular/core';


import { Observable, BehaviorSubject } from 'rxjs';
import { OktaConfig } from '@okta/okta-angular/src/okta/models/okta.config';
import { OktaSettings } from '../model/okta-settings';


// export interface IAppSettings {
//   oktaConfiguration?: OktaConfig;
//   googleAnalyticsTrackingId: string;
// }

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  settings: Observable<Readonly<OktaSettings>>;

  private settingsSource: BehaviorSubject<OktaSettings> = new BehaviorSubject<
  OktaSettings
  >({
      oktaConfiguration: undefined
  });

  constructor() {
    this.settings = this.settingsSource.asObservable();
  }

  setSettings(settings: Partial<OktaSettings>) {
    const updatedConfig = { ...this.settingsSource.value, ...settings };

    this.settingsSource.next(updatedConfig);
  }

  getSettings(): Readonly<OktaSettings> {
    return this.settingsSource.value;
  }
}